import cropr from "./cropr";
import moment from "moment";
import "moment/locale/nl";
import "moment/locale/fr";
import "moment/locale/de";
import "moment/locale/zh-cn";
import "moment/locale/es";
import "moment/locale/ru";
import "moment/locale/pt";
import "moment/locale/ja";

export function initMoment() {
  if (cropr && cropr.l10n) moment.locale(cropr.l10n.languageCode);
}
